import { z } from 'zod';

export type MarketplaceEventType = 'Promotion Requested' | 'Promote Clicked' | 'Promo Link Copied' | 'Bookmark Saved';

// Base schema for promote/request events with product context
const PromoteEventBaseSchema = z.object({
  productId: z.number().optional(),
  productName: z.string().optional(),
  productType: z.string().optional(),
  vendorName: z.string().optional(),
  source: z.string(),
  hasCompleteAddress: z.boolean(),
});

// Marketplace event payload schemas
export const PromotionRequestedPayloadSchema = PromoteEventBaseSchema;

export const PromoteClickedPayloadSchema = PromoteEventBaseSchema;

export const PromoLinkCopiedPayloadSchema = z.object({
  component_id: z.string(),
});

export const BookmarkSavedPayloadSchema = z.object({
  component_id: z.string(),
  item_type: z.string(),
});

export type MarketplaceEventTypePayloadMap = {
  'Promotion Requested': z.infer<typeof PromotionRequestedPayloadSchema>;
  'Promote Clicked': z.infer<typeof PromoteClickedPayloadSchema>;
  'Promo Link Copied': z.infer<typeof PromoLinkCopiedPayloadSchema>;
  'Bookmark Saved': z.infer<typeof BookmarkSavedPayloadSchema>;
};

export const MarketplaceEventSchemaMap = {
  'Promotion Requested': PromotionRequestedPayloadSchema,
  'Promote Clicked': PromoteClickedPayloadSchema,
  'Promo Link Copied': PromoLinkCopiedPayloadSchema,
  'Bookmark Saved': BookmarkSavedPayloadSchema,
};
